import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';


@NgModule({
    declarations: [DashboardComponent],

    imports: [
        SharedModule,
        DashboardRoutingModule
    ],
    exports: [],
    providers: [],
})
export class DashboardModule { }
